module.exports = __webpack_public_path__ + "img/2740747-99-1.23d92cbc.png";